export const data = [
  {
    id: 1,
    image: "t1.png",
    name: "Sunit Jain",
    Designation: "Managing Director",
    Description:
      " A communications professional with almost 15 years experience in telecom, advertising & media who leads the team from the front. Passionate about his team, learning and growing together and values relationships above everything else.",
  },
  {
    id: 2,
    image: "t2.png",
    name: "Swapan Sinha",
    Designation: "Associate Director",
    Description:
      "A media sales professional with over 20 years of experience, excelling in efficient man-management and selling skills with experience in Radio & TV Ad Sales.",
  },
  {
    id: 3,
    image: "t3.JPG",
    name: "Nishat Ahmed",
    Designation: "Creative Director",
    Description:
      "With an experience of over 15 years in advertising, she has worked in various ad agencies, on television commercials, branding, print and digital, both in Mumbai and now in Assam.",
  },
  {
    id: 4,
    image: "t4.png",
    name: "Rasween Das",
    Designation: "Account Director",
    Description:
      "A sharp-sighted brand servicing lead with 15+ years of experience. She has expertise in  integrated communication management for both FMCG brands and major Govt. Organisations both in New Delhi and Assam.",
  },
  {
    id: 5,
    image: "SalikKhan1.png",
    name: "Salik Khan",
    Designation: "Director Strategy and Govt. Affairs",
    Description:
      "Crafting messages with razor-sharp wit and strategic finesse, Salik's 13+ years odyssey has made him the maestro of impactful words and meaningful communications.",
  },
  {
    id: 6,
    image: "t6.png",
    name: "Ipshita Sinha",
    Designation: "Manager Digital Services",
    Description:
      "A digital marketing practitioner, aims to help brands stand out digitally & connect with the audience using contextual content marketing & paid ads.",
  },
];